import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/research.jpg";
import "../Pages/OurHistory.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import "../Pages/NewsandEvents.css"; // ← reuse styles for hero and breadcrumb

function Research() {
  return (
    <div className="ne-page">
      <SEO
        title="Research Projects"
        description="CIRCODU's research projects span a wide range of initiatives aimed at advancing sustainable development and environmental protection in Uganda and beyond."
        keywords="research, sustainable development, environmental protection, Uganda, CIRCODU, research projects"
        url="/our-services/research"
        type="website"
      />

      {/* Hero */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="ne-hero__overlay">
          <h4 className="ne-hero__title">Research Projects</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Our Services</Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Research Projects
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <section className="section border-bottom">
        <div className="container border-top">
          <div className="row">
            <div className="col-md-12 mt-2">
              {/* Intro */}
              <h5 style={{ color: "#008250", fontSize: "16px" }}>
                <b>Research Projects</b>
              </h5>
              <p className="texty">
                CIRCODU does not wait for change; we research it, measure it,
                and help make it happen. In partnership with local and
                international organizations, we have spearheaded a diverse
                portfolio of research projects that advance sustainable
                development across Uganda and the wider region.
              </p>

              {/* Clean Energy Research */}
              <h5 style={{ color: "#008250", fontSize: "14px" }}>
                <b>⚡ Clean Energy Research</b>
              </h5>
              <p className="texty">
                Our energy research runs deep. From assessing clean cooking
                needs and conducting national charcoal surveys to measuring
                behavioral change, willingness to pay, and consumer acceptance,
                we capture the full picture. We have supported local governments
                in energy planning, delivered customer insights, and evaluated
                the real-world impact of energy-efficient cookstoves on
                households and communities.
              </p>
              <p className="texty">
                We also actively monitor carbon projects under globally
                recognized frameworks, including the{" "}
                <b>
                  Gold Standard, Verra, and the Clean Development Mechanism
                  (CDM),
                </b>{" "}
                carrying out kitchen performance tests, emission tests, stove
                usage monitoring, water boiling tests, and household and
                institutional spot-check audits. Our contributions extend to
                reviewing standards and quality guidelines for renewable energy
                products and services across the sector.
              </p>

              {/* Sustainable Agriculture & Biogas */}
              <h5 style={{ color: "#008250", fontSize: "14px" }}>
                <b>🌾 Sustainable Agriculture and Biogas</b>
              </h5>
              <p className="texty">
                CIRCODU is breaking new ground in sustainable agriculture
                research. We investigate technologies that convert animal waste
                into biogas, optimizing program effectiveness, quality, and
                service delivery. Working alongside development agencies, we
                build business cases for household biogas users and biogas
                construction companies, factoring in the agricultural benefits
                of bio-slurry as a natural fertilizer and the energy savings
                that biogas adoption delivers.
              </p>
              <p className="texty">
                The result? Practical, evidence-backed solutions that improve
                livelihoods while reducing environmental footprints.
              </p>

              {/* Wetland Restoration & Water Management */}
              <h5 style={{ color: "#008250", fontSize: "14px" }}>
                <b>🔵 Wetland Restoration and Water Management</b>
              </h5>
              <p className="texty">
                In collaboration with trusted partners, CIRCODU has conducted
                in-depth studies on wetland restoration across Uganda. Our work
                includes developing detailed designs for small-scale water
                storage and detention facilities, alongside comprehensive plans
                for silt traps, drainage systems, flood control, and maximum
                water recovery because protecting nature's ecosystems is just as
                important as building within them.
              </p>

              <hr />

              {/* Closing statement */}
              <p className="texty">
                <i>
                  At CIRCODU, every research project carries the same purpose —
                  to improve lives today while protecting the world we leave
                  behind tomorrow.
                </i>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Research;
